import { render, staticRenderFns } from "./Navio.vue?vue&type=template&id=7b2e65a5"
import script from "./Navio.vue?vue&type=script&lang=js"
export * from "./Navio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports